<template>
  <v-card elevation="0">
    <v-card-title>Параметры локального сервера</v-card-title>
    <v-card-text>
      <v-row class="d-flex" dense>
        <v-col class="col-6">
          <v-text-field
            v-model="localServerConfig.host"
            label="Адрес сервера"
            hint="По умолчанию оставить 0.0.0.0, не устанавливать 127.0.0.1"
            persistent-hint
          ></v-text-field>
        </v-col>
        <v-col class="col-6">
          <v-text-field
            v-model="localServerConfig.port"
            label="Порт сервера"
            :rules="[rules.port]"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["localServerConfig"],
  methods: {
  },
  computed: {
    rules() {
      return {
        port: v => (/^\d+$/.test(v)) && (v >= 0) && (v <= 65535) || 'Значение должно быть от 0 до 65535'
      }
    }
  }
};
</script>

<style>
</style>